const selectors = {
    cartCheckout: document.querySelector('#cart-checkoutbtn'),
    checkoutSticky: document.querySelector('.checkoutbtn-sticky')
};

class templateCartJS {
    constructor() {

        if(window.globalVariables.cart.item_count > 0 || window.globalVariables.templateSuffix == 'subscription-flow' || window.globalVariables.templateSuffix == 'subscription-flow-new-test'){
            this.stickyCheckout();
        }
        if ( document.querySelectorAll("[checkout-btn]").length > 0) {
            document.querySelector("[checkout-btn]").addEventListener("click",()=>{
                ttq.track('InitiateCheckout',{  
                content_id: window.globalVariables.cart.items[0].id,
                value: `<span class="wh-original-cart-total"><span class='wh-original-price'>${Shopify.formatMoney(window.globalVariables.cart.total_price, window.globalVariables.money_format)}</span></span><span class="wh-cart-total"></span><div class="additional-notes"><span class="wh-minimums-note"></span><span class="wh-extra-note"></span></div>`,
                currency: 'USD',});
              console.log("click")
              window.location.href="/checkout"
          })
        }
    }

    // Sticky checkout container on oage scroll
    stickyCheckout(){
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.isIntersecting){
                    selectors.checkoutSticky.classList.remove('active');
                } else {
                    selectors.checkoutSticky.classList.add('active');
                }
            })
        });
            
        observer.observe(selectors.cartCheckout);
    }
}

typeof templateCartJS !== 'undefined' && new templateCartJS();
